<template>
  <div class="req-restore-container">
    <dx-form
      class="req-restore-password-form"
      :form-data="userCredentials"
      :read-only="loading"
      labelMode="floating"
      @initialized="saveFormInstance"
    >
      <dx-simple-item
        data-field="email"
        :editor-options="editorsOptions.email"
      >
        <dx-label :text="$t('authentication.email')"/>
        <dx-required-rule :message="$t('general.mandatory')"/>
        <dx-validation-rule
          type="pattern"
          :pattern="validationPatterns.email"
          :message="$t('general.badEmail')"
        />
      </dx-simple-item>
    </dx-form>

    <dx-button
      class="action-btn"
      type="default"
      width="100%"
      @click="restorePasswordClick()"
      :disabled="loading"
    >
      <template>
        <div class="button-container">
          <dx-load-indicator
            :visible="loading"
            class="button-indicator"
          />
          <span class="dx-button-text">{{ $t('authentication.btnforgotPassword') }}</span>
        </div>
      </template>
    </dx-button>

    <dx-button
      class="action-btn back-btn"
      type="normal"
      stylingMode="text"
      icon="spinleft"
      :text="$t('general.back')"
      :disabled="loading"
      @click="backClick"
    />

  </div>
</template>

<script>
import DxForm, {
  DxSimpleItem,
  DxLabel,
  DxRequiredRule,
  DxValidationRule
} from 'devextreme-vue/form';
import { DxButton, DxLoadIndicator } from 'devextreme-vue';

import { notifier } from '@/shared/lib/notifier/index';

import axios from "axios";
import { validationPatterns } from "@/utils/validation-patterns";

export default {
  components: {
    DxForm, DxSimpleItem, DxLabel, DxRequiredRule, DxValidationRule, DxButton, DxLoadIndicator
  },
  data() {
    return {
      validationPatterns,
      formInstance: null,
      userCredentials: {},
      loading: false,
    };
  },
  computed: {
    editorsOptions() {
      return {
        email: {inputAttr: {autocomplete:'off'}, maxLength: 256},
      }
    },
  },
  methods: {
    saveFormInstance(e) {
      this.formInstance = e.component;
    },
    validate() {
      const result = this.formInstance.validate();
      return result.isValid;
    },
    backClick() {
      this.$emit('update:isAuthentication', true);
    },
    restorePasswordClick() {
      if (!this.validate()) {
        return;
      }

      this.loading = true;
      axios.get(`${this.$store.getters.apiPath}/users/restore-password/${this.userCredentials.email}`).then((res) => {
        notifier.showSuccess(res.data.message);
        this.loading = false;
        this.$emit('update:isAuthentication', true);
      })
      .catch(err => {
        this.loading = false;
        notifier.showError(err.response.data.localizedMessage);
      });
    }
  },
  created() {
  }
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import url("../themes/fonts.css");

.req-restore-container {
  display: flex;
  flex-direction: column;

  .req-restore-password-form {
    margin-bottom: 10px;
  }
}

.action-btn {
  font-family: 'Golos Text', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.back-btn {
  align-self: center;
  margin-top: 10px;
}
.button-indicator {
  height: 24px;
  width: 24px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  .dx-loadindicator-icon {
    .dx-loadindicator-segment {
      background: white;
    }
  }
}

.button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.validation-margin {
  margin-bottom: 2.5rem;
}

</style>
